
export const PartnerLevelHealthMobility  = {

  PARTNER: {text: '1', value: 1},
  
}
